import { IconButton, InputAdornment, TextField } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import React, { useState } from "react";

type PasswordInputProps = React.ComponentProps<typeof TextField>;

export const PasswordInput = (props: PasswordInputProps) => {
  // const {TextDomainContext} = useTextDomainContext();
  // const {gettext} = useContext(TextDomainContext);

  const [showPassword, setShowPassword] = useState(false);
  // const [value, setValue] = useState("");
  //
  // useEffect(() => {
  //   if (props.value) {
  //     setValue(props.value);
  //   }
  // }, [props.value]);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  // const handleMouseDownPassword = event => {
  //   event.preventDefault();
  // };

  return (
    <>
      <TextField
        type={showPassword ? "text" : "password"}
        // label={props.label || null}
        // placeholder={props.placeholder || gettext("Password")}
        // size={props.size || "small"}
        // required={props.required || false}
        // fullWidth={props.fullWidth || false}
        // autoComplete="new-password"
        // value={value}
        // onChange={onChange}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  edge="end"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
        {...props}
      />

      {/*<OutlinedInput*/}
      {/*  type={showPassword ? "text" : "password"}*/}
      {/*  placeholder={gettext("Password")}*/}
      {/*  endAdornment={*/}
      {/*    <InputAdornment position="end" sx={{*/}
      {/*      color: "#D4D4D8"*/}
      {/*    }}>*/}
      {/*      <IconButton*/}
      {/*        aria-label="toggle password visibility"*/}
      {/*        onClick={handleClickShowPassword}*/}
      {/*        onMouseDown={handleMouseDownPassword}*/}
      {/*        edge="end"*/}
      {/*        color="inherit"*/}
      {/*        size="small"*/}
      {/*      >*/}
      {/*        {showPassword ? <Visibility/> : <VisibilityOff/>}*/}
      {/*      </IconButton>*/}
      {/*    </InputAdornment>*/}
      {/*  }*/}
      {/*  {...props}*/}
      {/*/>*/}
    </>
  );
};
